import { FC, PropsWithChildren } from "react"
import "./MainLayout.less"

const MainLayout: FC<{ className?: string } & PropsWithChildren> = ({ className, children }) => {
  return <div className={`${className ? className : ""} main-layout-content`}>{children}</div>
}

export default MainLayout
